<template>
    <div class="goods-content">
      <div class="boxcontent-item" v-for="order in orderTypes" :key="order.id" @click="$emit('on-open-form', order.modal)">
        <i class="fas fa-door-closed"></i>
        <p class="boxcontent-item-title">{{ order.name }}</p>
      </div>
    </div>
</template>

<script>
export default {
  name: "SupplierOrdersButtons",
  data() {
    return {
      orderTypes: [
        {
          name: "Drzwi",
          modal: "doors"
        },
      ]
    };
  },
};
</script>
